import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class WorkshopNews extends ModelPrototype {
  public async get(): Promise<any> {
    try {
      return this.withUrl(`main/workshop_news`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
